import get from 'get-value';
import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';

export const docExportDealers = (state = {
    isLoadingDealer: false,
    dealers: [],
    correlationId: null,
    searchResults: null,
}, action) => {
    switch (action.type) {
        case techDocWebsocketCommands.TECH_DOC_DEALERS_GET: {
            const hasSearchTerm = get(action, 'payload.searchTerm');
            return Object.assign({}, state, { 
                isLoadingDealer: !hasSearchTerm // Don't show loading for search requests
            });
        }
        case techDocWebsocketCommands.TECH_DOC_DEALERS_SEND: {
            const dealers = get(action, 'payload.dealers', { default: [] });
            const correlationId = get(action, 'payload.correlationId');
            
            // If this response has a correlationId starting with 'search_', it's from a search request
            if (correlationId && correlationId.includes('search_')) {
                return Object.assign({}, state, {
                    searchResults: { 
                        dealers: dealers.map(dealer => ({...dealer})), // Deep copy each dealer object
                        correlationId 
                    }
                });
            }
            
            // Regular dealer loading
            return Object.assign({}, state, {
                isLoadingDealer: false,
                dealers: dealers.map(dealer => ({...dealer})), // Deep copy each dealer object
            });
        }
        case techDocWebsocketCommands.TECH_DOC_DEALERS_SEND_ERROR: {
            return Object.assign({}, state, { isLoadingDealer: false });
        }
        default:
            return state;
    }
};
